import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useEntityContext } from '@/hooks/entity-context.hook';
import EntitySelectionScreen from '@/components/Entity/entity-selection-screen';
import { Skeleton } from '@/components/ui/skeleton';

export default function EntityWorkspaceGate({ children }: { children: React.ReactElement }) {
  const { initialized, loading, current, selectionRequired, currentApplication, error, initialize } =
    useEntityContext();

  useEffect(() => {
    if (!initialized && !loading) void initialize();
  }, [initialize, initialized, loading]);

  if (!initialized || loading) {
    return (
      <div className="min-h-screen bg-secondary px-[1.6rem] py-[2.4rem] sm:px-[3rem]">
        <div className="mx-auto w-full max-w-[118rem] space-y-[2rem]">
          <div className="flex items-center justify-between gap-[2rem]">
            <Skeleton className="h-[3.2rem] w-[14rem] rounded-[0.8rem]" />
            <Skeleton className="h-[3.8rem] w-[3.8rem] rounded-full" />
          </div>
          <div className="mx-auto max-w-[72rem] space-y-[1.6rem] pt-[8vh]">
            <Skeleton className="mx-auto h-[3.6rem] w-[25rem] max-w-full rounded-[0.8rem]" />
            <Skeleton className="mx-auto h-[1.6rem] w-[38rem] max-w-full rounded-[0.6rem]" />
            <div className="grid gap-[1.2rem] pt-[1.6rem] sm:grid-cols-2">
              {[1, 2, 3, 4].map((item) => (
                <Skeleton key={item} className="h-[10rem] w-full rounded-[1.2rem]" />
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (selectionRequired) return <EntitySelectionScreen />;
  if (current) return children;

  if (error) {
    return <div className="min-h-screen grid place-items-center px-6 text-[1.4rem] text-red-600">{error}</div>;
  }

  return <Navigate to={currentApplication?.status === 'UnderReview' ? '/kyc/pending' : '/kyc/submit'} replace />;
}
